import React from 'react';
import { TableCell } from '@mui/material';

export const ProjectTitleCell = () => (
  <TableCell align="left">
    Project
  </TableCell>
);

export const ProjectDescriptionCell = () => (
  <TableCell align="left" width="30%">
    Description
  </TableCell>
);

export const ProjectDevicesCell = () => (
  <TableCell align="left">Devices</TableCell>
);

export const ProjectUsersCell = () => (
  <TableCell align="left" width="15%">
    Users
  </TableCell>
);

export const ProjectDateCell = () => (
  <TableCell align="left" width={170}>
    Date
  </TableCell>
);

export const ProjectLogsCell = () => (
  <TableCell width={50} />
);

export const ProjectEditCell = () => (
  <TableCell width={50} />
);
